/* eslint-disable no-undef */
(function (window) {
    "use strict";
    function defineCustomerCreditsService() {
        let customerCreditsService = {};
        customerCreditsService.getCompanyCreditHistoryByCompany = function (request){
            return axios.post("/api/CustomerCreditsService/GetCompanyCreditHistoryByCompany", request);
        };
        customerCreditsService.getCurrentCompanyCreditByCompany = function (){
            return axios.get("/api/CustomerCreditsService/GetCurrentCompanyCreditByCompany");
        };
        return customerCreditsService;
    }
    //define globally if it doesn't already exist
    if (typeof (customerCreditsService) === "undefined") {
        window.customerCreditsService = defineCustomerCreditsService();
    } else {
        console.log("customerCreditsService already defined.");
    }
})(window);